import { TIMETOKEN_MULTIPLIER } from './message-date-time';

const ONE_SECOND_IN_TIMETOKEN = 1000 * TIMETOKEN_MULTIPLIER;

export const getQueryTypeStarttoken = (
  startTimeToken: string | undefined,
  endTimeToken: string | undefined
): string | undefined => {
  if (!startTimeToken || !endTimeToken) {
    return undefined;
  }

  const parsedGrowStartTimeToken = Number(startTimeToken);
  const parsedGrowEndTimeToken = Number(endTimeToken);

  if (
    Number.isNaN(parsedGrowStartTimeToken) ||
    Number.isNaN(parsedGrowEndTimeToken)
  ) {
    return undefined;
  }

  return String(
    Math.max(parsedGrowStartTimeToken, parsedGrowEndTimeToken) +
      ONE_SECOND_IN_TIMETOKEN
  );
};
